import { motion } from "framer-motion";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { ChapterShell } from "../ChapterShell";
import { FadeUp, MaskedLines } from "../Reveal";
import { MagneticButton } from "../MagneticButton";
import { LINKEDIN, EMAIL, PHONE, HEADSHOT_FALLBACK } from "../../data/content";
import { imgFallback } from "../../utils";

const ORBIT_WORDS = ["Doctors", "Patients", "Products", "Data", "AI", "Marketing", "Sales", "Strategy", "Growth"];

export const ChapterEleven = () => (
  <ChapterShell n="11" id="connect" era="Tomorrow" title="The Future" dark className="pb-16">
    <div className="flex flex-col items-center text-center">
      <FadeUp className="relative">
        <div className="absolute -inset-10 rounded-full bg-[#00E5FF]/15 blur-3xl" />
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 55, repeat: Infinity, ease: "linear" }}
          className="absolute -inset-8 rounded-full border border-dashed border-white/15"
        />
        <div className="glass-dark relative overflow-hidden rounded-[2rem] p-2">
          <img
            src="/assets/avatar-hero.png"
            onError={imgFallback(HEADSHOT_FALLBACK)}
            alt="Rishikesh Sharma — final hero pose"
            data-testid="chapter11-avatar"
            className="w-64 rounded-[1.6rem] object-cover md:w-72"
          />
        </div>
      </FadeUp>

      <FadeUp delay={0.15} className="mt-10 flex max-w-2xl flex-wrap justify-center gap-3">
        {ORBIT_WORDS.map((w) => (
          <span
            key={w}
            className="rounded-full border border-white/15 bg-white/5 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-white/70"
          >
            {w}
          </span>
        ))}
      </FadeUp>

      <h3 className="mt-12 font-display text-5xl font-black tracking-tight text-white md:text-7xl">
        <MaskedLines lines={["THE JOURNEY", "CONTINUES."]} />
      </h3>
      <FadeUp delay={0.25} className="mt-6 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
        Building brands today. Creating possibilities for tomorrow.
      </FadeUp>

      <FadeUp delay={0.35} className="mt-10">
        <MagneticButton testId="lets-connect-btn" variant="cyan" href={LINKEDIN}>
          Let's Connect
          <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </MagneticButton>
      </FadeUp>

      <FadeUp delay={0.45} className="mt-12 flex flex-wrap items-center justify-center gap-6 text-sm text-white/55">
        <a
          href={`mailto:${EMAIL}`}
          data-testid="contact-email"
          className="flex items-center gap-2 transition-colors hover:text-[#00E5FF]"
        >
          <Mail size={15} /> {EMAIL}
        </a>
        <span className="hidden h-4 w-px bg-white/20 sm:block" />
        <a
          href={`tel:${PHONE.replace(/\s/g, "")}`}
          data-testid="contact-phone"
          className="flex items-center gap-2 transition-colors hover:text-[#00E5FF]"
        >
          <Phone size={15} /> {PHONE}
        </a>
      </FadeUp>
    </div>

    <footer className="mt-24 border-t border-white/10 pt-8 text-center">
      <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-white/35">
        Rishikesh Sharma · General Manager — Marketing · From the Field to the Future of Pharma Marketing
      </p>
    </footer>
  </ChapterShell>
);
